module.exports = __webpack_public_path__ + "static/media/startseitenslider02.8ab57b13.jpg";